<div *ngIf="!loading">
  <div class="spinner"></div>
  <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por favor aguarde ...
  </p>
</div>

<div *ngIf="loading" class="animated fadeIn">
  <div class="timeline-body">

    <div class="form-group">
      <label>3.1 – Estrutura Física:</label>

      <div class="radio">
        <label>
          <input type="radio" name="optionsRadios" id="optionsRadios1" [(ngModel)]="capacidadeInstalada.estruturaFisica"
            (click)="capacidadeInstaladaDiferenteOutro()" value="0"> Própria
        </label>
        &nbsp;&nbsp;&nbsp;
        <label>
          <input type="radio" name="optionsRadios" id="optionsRadios2" [(ngModel)]="capacidadeInstalada.estruturaFisica"
            (click)="capacidadeInstaladaDiferenteOutro()" value="1"> Cedida
        </label>
        &nbsp;&nbsp;&nbsp;
        <label>
          <input type="radio" name="optionsRadios" id="optionsRadios3" [(ngModel)]="capacidadeInstalada.estruturaFisica"
            (click)="capacidadeInstaladaDiferenteOutro()" value="2"> Alugada
        </label>
        &nbsp;&nbsp;&nbsp;
        <label>
          <input type="radio" name="optionsRadios" id="optionsRadios4" [(ngModel)]="capacidadeInstalada.estruturaFisica"
            (click)="capacidadeInstaladaIgualOutro()" value="3"> Outro
        </label>
      </div>
    </div>
    <div class="form-group" *ngIf="mostraObsCapacidadeInstalada">
      <label>Observação:</label>
      <input type="text" [(ngModel)]="capacidadeInstalada.estruturaFisicaOutro" class="form-control">
    </div>
    <div class="timeline-footer">
      <a class="btn btn-primary btn-sm" (click)="modificaCapacidadeInstalada()">Realizar ajuste</a>
    </div>
    <br>
   








    <div class="form-group" *ngIf="mostraItensCapacidadeInstalada">
      <label for="imput13">3.2 – Equipe de Profissionais Permanente da OSC</label>
      <p class="help-block">Informar a composição da equipe de profissionais que trabalham na entidade</p>

      <div class="box">
        <div class="box-header">
          <h3 class="box-title">Lista da equipe cadastrada</h3>
          <div class="box-tools">
            <button type="submit" (click)="openModalAddEquipe(formAdicionarEquipe)"
              class="btn btn-success btn-sm pull-right">
              <i class="fa fa-plus"></i> Add profissional</button>
          </div>
        </div>
        <div class="box-body table-responsive no-padding">
          <table class="table table-hover">
            <tbody>
              <tr>
                <th>Nome</th>
                <th>Formação</th>
                <th>Função na Entidade</th>
                <th>Carga Horária Trabalho</th>
                <th class="text-center" style="min-width: 65px;">Ações</th>
              </tr>
              <tr *ngFor="let prof of equipe">
                <td>{{ prof.nome }}</td>
                <td>{{ verificaFormacao(prof.formacao) }}</td>
                <td>{{ prof.funcao }}</td>
                <td>{{ prof.cargaHoraria }}</td>
                <td class="text-center">
                  <i (click)="openModalEditarEquipe(prof)" class="fa fa-edit" data-toggle="tooltip" data-placement="right"
                    title="Editar" style="font-size: 20px; cursor:pointer; color: #2017a0c7;"></i>&nbsp;&nbsp;
                  <i (click)="confirmarExclusaoEquipe(prof)" class="fa fa-trash" data-toggle="tooltip"
                    data-placement="right" title="Excluir"
                    style="font-size: 20px; cursor:pointer; color: #ff3636ab;"></i>
                </td>

              </tr>
              <tr style="color: #ff3636ab;" *ngIf="equipe == ''">
                <td>Nenhum profissional cadastrado!</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>







    <div class="form-group" *ngIf="mostraItensCapacidadeInstalada">
      <label for="imput13">3.3 – Instalações físicas</label>
      <p class="help-block">Informar o número de cômodos existentes na instituição e quais são as principais atividades
        realizadas em cada
        espaço
      </p>

      <div class="box">
        <div class="box-header">
          <h3 class="box-title">Lista de instalações</h3>
          <div class="box-tools">
            <button type="submit" (click)="openModalAddInstalacoesFisicas(formAdicionarInstalacoesFisicas)"
              class="btn btn-success btn-sm pull-right">
              <i class="fa fa-plus"></i> Add espaço</button>
          </div>
        </div>
        <div class="box-body table-responsive no-padding">
          <table class="table table-hover">
            <tbody>
              <tr>
                <th>Cômodo</th>
                <th>Quantidade</th>
                <th>Tipo de atividades desenvolvidas no espaço</th>
                <th class="text-center" style="min-width: 65px;">Ações</th>
              </tr>
              <tr *ngFor="let instal of instalacoesFisicas">
                <td>{{ instal.comodo }}</td>
                <td>{{ instal.quantidade }}</td>
                <td>{{ instal.tipoAtividadeDesenv }}</td>
                <td class="text-center">
                  <i (click)="openModalEditarInstalacoesFisicas(instal)" class="fa fa-edit" data-toggle="tooltip"
                    data-placement="right" title="Editar"
                    style="font-size: 20px; cursor:pointer; color: #2017a0c7;"></i>&nbsp;&nbsp;
                  <i (click)="confirmarExclusaoInstalacoesFisicas(instal)" class="fa fa-trash" data-toggle="tooltip"
                    data-placement="right" title="Excluir"
                    style="font-size: 20px; cursor:pointer; color: #ff3636ab;"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>





    <div class="form-group" *ngIf="mostraItensCapacidadeInstalada">
      <label for="imput13">3.4 – Equipamentos Disponíveis:</label>
      <p class="help-block">Informar os tipos e a quantidade de equipamentos existentes na instituição que poderão ser
        utilizados durante
        a execução do objeto</p>

      <div class="box">
        <div class="box-header">
          <h3 class="box-title">Lista de equipamentos</h3>
          <div class="box-tools">
            <button type="submit" (click)="openModalAddEquipamentosDisponiveis(formAdicionarEquipamentosDisponiveis)"
              class="btn btn-success btn-sm pull-right">
              <i class="fa fa-plus"></i> Add equipamento</button>
          </div>
        </div>
        <div class="box-body table-responsive no-padding">
          <table class="table table-hover">
            <tbody>
              <tr>
                <th>Tipo de Equipamento</th>
                <th>Quantidade</th>
                <th class="text-center" style="min-width: 65px;">Ações</th>
              </tr>
              <tr *ngFor="let equip of equipamentosDisponiveis">
                <td>{{ equip.tipoEquipamento }}</td>
                <td>{{ equip.quantidade }}</td>
                <td class="text-center">
                  <i (click)="openModalEditarEquipamentosDisponiveis(equip)" class="fa fa-edit" data-toggle="tooltip"
                    data-placement="right" title="Editar"
                    style="font-size: 20px; cursor:pointer; color: #2017a0c7;"></i>&nbsp;&nbsp;
                  <i (click)="confirmarExclusaoEquipamentosDisponiveis(equip)" class="fa fa-trash" data-toggle="tooltip"
                    data-placement="right" title="Excluir"
                    style="font-size: 20px; cursor:pointer; color: #ff3636ab;"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  
  </div>

  <!--
  <div *ngIf="mostraItensCapacidadeInstalada">
    <div class="timeline-footer" *ngIf="etapa3">
      &nbsp;&nbsp;
      <a class="btn btn-primary btn-sm" (click)="openEtapa2()">Voltar</a>
      <a class="btn btn-primary btn-sm" (click)="openEtapa4()">Continuar</a>
      <br>
      <br>
    </div>
  </div>
-->
</div>







<p-dialog [style]="{width: '600px'}" (onHide)="closeModalEditarInstalacoesFisicas()" header="Editar espaço "
  [(visible)]="modalEditarInstalacoesFisicas" showEffect="fade" [modal]="true">
  <form #formAlterarInstalacoesFisicas="ngForm" autocomplete="off"
    (ngSubmit)="alterarInstalacoesFisicas()">
    <div class="ui-g">
      <div class="ui-g-12 ui-fluid">
        <label>*Cômodo</label>
        <input pInputText type="text" name="comodo" [(ngModel)]="instalacoesFisicasEditar.comodo" required>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Quantidade</label>
        <input pInputText type="text" name="quantidade" [(ngModel)]="instalacoesFisicasEditar.quantidade" required>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Tipo de atividade desenvolvida</label>
        <input pInputText type="text" name="tipoAtividadeDesenv"
          [(ngModel)]="instalacoesFisicasEditar.tipoAtividadeDesenv" required>
        <small style="float:right; margin: 10px 0 0 0">*Preechimento obrigatório</small>
      </div>
      <div class="ui-g-12">
        <button pButton type="submit" label="Salvar" [disabled]="formAlterarInstalacoesFisicas.invalid"></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog [style]="{width: '600px'}" header="Novo espaço" [(visible)]="modalAdicionarInstalacoesFisicas" showEffect="fade"
  [modal]="true">
  <form #formAdicionarInstalacoesFisicas="ngForm" autocomplete="off"
    (ngSubmit)="adicionarInstalacoesFisicas(formAdicionarInstalacoesFisicas)">
    <div class="ui-g">
      <div class="ui-g-12 ui-fluid">
        <label>*Cômodo</label>
        <input pInputText type="text" name="comodo" [(ngModel)]="instalacoesFisicasAdd.comodo" required>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Quantidade</label>
        <input pInputText type="text" name="quantidade" [(ngModel)]="instalacoesFisicasAdd.quantidade" required>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Tipo de atividade desenvolvida</label>
        <input pInputText type="text" name="tipoAtividadeDesenv" [(ngModel)]="instalacoesFisicasAdd.tipoAtividadeDesenv"
          required>
        <small style="float:right; margin: 10px 0 0 0">*Preechimento obrigatório</small>
      </div>
      <div class="ui-g-12">
        <button pButton type="submit" label="Salvar" [disabled]="formAdicionarInstalacoesFisicas.invalid"></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog [style]="{width: '600px'}" header="Novo profissional" [(visible)]="modalAdicionarEquipe" showEffect="fade"
  [modal]="true">
  <form #formAdicionarEquipe="ngForm" autocomplete="off" (ngSubmit)="adicionarEquipe(formAdicionarEquipe)">
    <div class="ui-g">
      <div class="ui-g-12 ui-fluid">
        <label>*Nome</label>
        <input pInputText type="text" name="nome" [(ngModel)]="equipeAdd.nome" required>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Formação</label>
        <p-select name="formacao" [options]="formacao" placeholder="Selecione" [filter]="true"
          [(ngModel)]="equipeAdd.formacao" required></p-select>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Função</label>
        <input pInputText type="text" name="funcao" [(ngModel)]="equipeAdd.funcao" required>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Carga horária</label>
        <input pInputText type="text" name="cargaHoraria" [(ngModel)]="equipeAdd.cargaHoraria" required>
        <small style="float:right; margin: 10px 0 0 0">*Preechimento obrigatório</small>
      </div>
      <div class="ui-g-12">
        <button pButton type="submit" label="Salvar" [disabled]="formAdicionarEquipe.invalid"></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog [style]="{width: '600px'}" (onHide)="closeModalEditarEquipe()" header="Editar profissional" [(visible)]="modalEditarEquipe" showEffect="fade" [modal]="true">
  <form #formAlterarEquipe="ngForm" autocomplete="off" (ngSubmit)="alterarEquipe()">
    <div class="ui-g">
      <div class="ui-g-12 ui-fluid">
        <label>*Nome</label>
        <input pInputText type="text" name="nome" [(ngModel)]="equipeEditar.nome" required>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Formação</label>
        <p-select name="formacao" [options]="formacao" placeholder="Selecione" [filter]="true"
          [(ngModel)]="equipeEditar.formacao" required></p-select>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Função</label>
        <input pInputText type="text" name="funcao" [(ngModel)]="equipeEditar.funcao" required>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Carga horária</label>
        <input pInputText type="text" name="cargaHoraria" [(ngModel)]="equipeEditar.cargaHoraria" required>
        <small style="float:right; margin: 10px 0 0 0">*Preechimento obrigatório</small>
      </div>
      <div class="ui-g-12">
        <button pButton type="submit" label="Salvar" [disabled]="formAlterarEquipe.invalid"></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog [style]="{width: '600px'}" header="Novo equipamento" [(visible)]="modalAdicionarEquipamentosDisponiveis"
  showEffect="fade" [modal]="true">
  <form #formAdicionarEquipamentosDisponiveis="ngForm" autocomplete="off"
    (ngSubmit)="adicionarEquipamentosDisponiveis(formAdicionarEquipamentosDisponiveis)">
    <div class="ui-g">
      <div class="ui-g-12 ui-fluid">
        <label>*Tipo de equipamento</label>
        <input pInputText type="text" name="tipoEquipamento" [(ngModel)]="equipamentosDisponiveisAdd.tipoEquipamento"
          required>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Quantidade</label>
        <input pInputText type="text" name="quantidade" [(ngModel)]="equipamentosDisponiveisAdd.quantidade" required>
        <small style="float:right; margin: 10px 0 0 0">*Preechimento obrigatório</small>
      </div>
      <div class="ui-g-12">
        <button pButton type="submit" label="Salvar" [disabled]="formAdicionarEquipamentosDisponiveis.invalid"></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog [style]="{width: '600px'}" (onHide)="closeModalEditarEquipamentosDisponiveis()" header="Editar equipamento "
  [(visible)]="modalEditarEquipamentosDisponiveis" showEffect="fade" [modal]="true">
  <form #formAlterarEquipamentosDisponiveis="ngForm" autocomplete="off"
    (ngSubmit)="alterarEquipamentosDisponiveis()">
    <div class="ui-g">
      <div class="ui-g-12 ui-fluid">
        <label>*Tipo de equipamento</label>
        <input pInputText type="text" name="tipoEquipamento" [(ngModel)]="equipamentosDisponiveisEditar.tipoEquipamento"
          required>
      </div>
      <div class="ui-g-12 ui-fluid">
        <label>*Quantidade</label>
        <input pInputText type="text" name="quantidade" [(ngModel)]="equipamentosDisponiveisEditar.quantidade" required>
        <small style="float:right; margin: 10px 0 0 0">*Preechimento obrigatório</small>
      </div>
      <div class="ui-g-12">
        <button pButton type="submit" label="Salvar" [disabled]="formAlterarEquipamentosDisponiveis.invalid"></button>
      </div>
    </div>
  </form>
</p-dialog>
